import { Box, Button, styled, Typography } from '@mui/material';
import { useAppDispatch } from '../../../../app/hooks';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { setUploadedBlockGeoJSON } from '../../onboardingSlice';
import { BlockBoundaryAndOrientationSubmitButton } from './BlockBoundaryAndOrientationSubmitButton';
import BlockUploader from './BlockUploader';
import CustomTitleDivider from './CustomTitleDivider';

interface Props {
  handleSendBlockBoundaryClick: (type: 'draw' | 'upload') => Promise<void>;
  isSubmitDisabled: boolean;
}
const StyledBox = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const BlockBoundaryFormTabUploadSection: React.FC<Props> = ({
  handleSendBlockBoundaryClick,
  isSubmitDisabled,
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        p: '0.5rem',
        border: (theme) => `1px solid ${theme.colors.darkTheme.grey.muted}`,
        borderRadius: (theme) => theme.borderRadius.primary,
        display: 'grid',
        gridTemplateRows: 'min-content min-content 1fr min-content',
        gridTemplateColumns: '1fr',
      }}
    >
      <StyledBox>
        <Typography
          variant='h5'
          sx={{ color: (theme) => theme.colors.common.bloomfieldGreen }}
        >
          {t('Upload', { ns: 'common' })}
        </Typography>
      </StyledBox>
      <CustomTitleDivider />
      <StyledBox>
        <BlockUploader />
      </StyledBox>
      <StyledBox sx={{ gap: '0.5rem' }}>
        <Button
          variant='contained'
          color='secondary'
          fullWidth
          onClick={() => dispatch(setUploadedBlockGeoJSON(null))}
        >
          {t('Clear File', { ns: 'common' })}
        </Button>
        <BlockBoundaryAndOrientationSubmitButton
          onClick={() => handleSendBlockBoundaryClick('upload')}
          disabled={isSubmitDisabled}
        />
      </StyledBox>
    </Box>
  );
};

export default BlockBoundaryFormTabUploadSection;
